import React, { useState } from "react";
import "./Features.css";
import { Post } from "../../common/services/posts.types";
import Navbar from "../../components/layout/Navbar/Navbar";
import Footer from "../../components/layout/Footer/Footer";

const samplePosts: Post[] = [
  {
    id: 1,
    title: "Vendor Logistics — Book Riders for Deliveries",
    date: "May 1, 2025",
    tags: ["vendor", "logistics"],
    excerpt:
      "We launched Vendor Logistics so food, drinks and pastry vendors can book riders to deliver orders.",
    content:
      "Vendor Logistics (launched May 1, 2025) enables vendors to schedule and book trusted riders for last-mile delivery. The feature supports multi-drop routes, assigned time windows, and proof-of-delivery workflows tailored for food, beverages and pastry sellers. Vendors can now manage rider availability and track deliveries end-to-end from the Vendor Dashboard.",
  },
  {
    id: 2,
    title: "Virtual Kitchen — Order From Your Favourite Vendors",
    date: "Nov 1, 2025",
    tags: ["virtual-kitchen", "restaurants"],
    excerpt:
      "Virtual Kitchen brings your favourite restaurants and vendors into the app as delivery-friendly kitchens.",
    content:
      "Virtual Kitchen (launched Nov 1, 2025) lets vendors and restaurants operate delivery-first kitchens inside the platform. Users can now order from a curated selection of partner virtual kitchens — the same great dishes, optimized for delivery. This rollout includes menu consolidation, streamlined kitchen routing, and improved ETA predictions for a better at-home dining experience.",
  },
  {
    id: 3,
    title: "Custom Public Links for Vendors",
    date: "Nov 24, 2025",
    tags: ["vendor", "links", "marketing"],
    excerpt:
      "Vendors can share public profile and dish links (e.g. https://www.squaay.com/username) to social bios and posts.",
    content:
      "Custom Public Links (launched Nov 24, 2025) enable vendors to publish a short, shareable URL for their profile or individual meals. Vendors can paste the link into their Instagram bio, website, or marketing channels and customers land directly on the vendor’s virtual kitchen or menu. The feature also supports tracking parameters so vendors can measure traffic from specific campaigns.",
  },
];

const Features: React.FC = () => {
  const [expanded, setExpanded] = useState<number | null>(null);

  const toggle = (id: number) =>
    setExpanded((prev) => (prev === id ? null : id));

  const posts = [...samplePosts].reverse();

  return (
    <div className="home-container">
      <Navbar />
      <section className="updates-page">
        <div className="updates-wrapper">
          <header className="updates-header">
            <span className="section-label">Changelog</span>
            <h1 className="updates-title">Product Updates</h1>
            <p className="updates-subtitle">
              New features and improvements, in the order we shipped them.
            </p>
          </header>

          <div className="updates-timeline">
            {posts.map((post, index) => (
              <article className="update-entry" key={post.id}>
                <div className="update-entry-marker">
                  <span className="update-entry-dot" />
                  {index !== posts.length - 1 && (
                    <span className="update-entry-line" />
                  )}
                </div>

                <div className="update-entry-body">
                  <time className="update-entry-date">{post.date}</time>
                  <h2 className="update-entry-title">{post.title}</h2>

                  <div className="update-entry-tags">
                    {post.tags.map((t) => (
                      <span key={t} className="tag">
                        {t}
                      </span>
                    ))}
                  </div>

                  <p className="update-entry-excerpt">{post.excerpt}</p>

                  {expanded === post.id && (
                    <p className="update-entry-content">{post.content}</p>
                  )}

                  <button
                    className="update-entry-toggle"
                    onClick={() => toggle(post.id)}
                  >
                    {expanded === post.id ? "Show less" : "Read more"}
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Features;
